import React from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
    IconButton,
    InputAdornment,
    TextField,
    TextFieldProps,
} from '@mui/material';

import { Controller, useFormContext } from 'react-hook-form';
import { colors } from 'common/constants';

type BaseTextFieldProps = TextFieldProps & {
    name: string;
};

const BaseTextPasswordField: React.FC<BaseTextFieldProps> = ({
    name,
    ...props
}) => {
    const { control } = useFormContext();
    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <TextField
                    {...field}
                    error={!!fieldState.error}
                    helperText={
                        fieldState.error ? fieldState.error.message : ''
                    }
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() =>
                                        setShowPassword(!showPassword)
                                    }
                                    onMouseDown={(e) => e.preventDefault()}
                                    onMouseUp={(e) => e.preventDefault()}
                                >
                                    {showPassword ? (
                                        <Visibility />
                                    ) : (
                                        <VisibilityOff />
                                    )}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    FormHelperTextProps={{
                        sx: {
                            fontSize: '14px',
                            marginLeft: 0,
                            color: `${colors.textError} !important`,
                            fontWeight: '400',
                        },
                    }}
                    {...props}
                />
            )}
        />
    );
};

export default BaseTextPasswordField;
